import cn from 'classnames';
import { ButtonHTMLAttributes, ReactNode } from 'react';
import s from './Button.module.scss';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    color?: 'blue' | 'yellow';
    fillMode?: 'fill' | 'empty';
    width: 'full' | 'full-inline' | 'inline';
    customClass?: string;
    isWithIcon?: boolean;
    size?: 'small' | 'normal';
}

const Button = ({
    color = 'blue',
    fillMode = 'empty',
    width,
    customClass,
    isWithIcon,
    size = 'normal',
    children,
    ...props
}: Props) => {
    return (
        <button
            {...props}
            className={cn(s.btn, {
                [s.btn_empty]: fillMode === 'empty',
                [s.btn_fill]: fillMode === 'fill',

                [s.btn_blue]: color === 'blue',
                [s.btn_yellow]: color === 'yellow',

                [s.btn_full]: width === 'full',
                [s.btn_full_inline]: width === 'full-inline',
                [s.btn_inline]: width === 'inline',
                [s.btn_ic]: isWithIcon,
                [s.btn_small]: size === 'small',
                [s.btn_normal]: size === 'normal',

                [`${customClass}`]: customClass,
            })}
        >
            {children}
        </button>
    );
};

export default Button;
